<template>
  <section class="register-2">
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div
          class="content-wrapper d-flex align-items-stretch auth auth-img-bg"
          style="overflow: hidden"
        >
          <div class="row flex-grow">
            <div class="col-lg-6 d-flex align-items-center justify-content-center">
              <div class="auth-form-transparent text-center p-3 col-md-12 col-lg-9">
                <div class="brand-logo">
                  <img :src="require('@/assets/images/logo2.png')" alt="logo" />
                </div>

                <h3>{{ $t('company.activation.title') }}</h3>
                <h6 class="mt-2">{{ $t('company.activation.subtitle') }}</h6>

                <loader class="mt-5"></loader>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 login-half-bg d-flex flex-row">
              <p class="text-white font-weight-medium text-center flex-grow align-self-end">
                Copyright &copy; {{ date }}
                All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import userInfoQuery from '@/api/user/userInfo.gql';
export default {
  name: 'CreatingCompany',
  data() {
    return {};
  },
  apollo: {
    currentUser: {
      query() {
        return userInfoQuery;
      },
      pollInterval: 1000,
      update(data) {
        if (!data || !data.koeeBoxQuery) {
          return null;
        }
        return data.koeeBoxQuery.currentUser;
      },
      error(e) {
        this.$store.commit('SET_ERROR', e.message);
      },
    },
  },
  watch: {
    currentUser: function (v) {
      if (v && v.group === this.$store.getters.groupIdPm) {
        this.$authCore.SetUserRole('Admin');
        this.$store.commit('SET_ADDITIONAL_DATA', v);
        this.$routerCore.GoToHomePage();
      }
    },
  },
};
</script>
